import http from "../api/http";
import { get } from "lodash";

import * as actionType from "./actionType";
import { message } from "antd";
import intl from "react-intl-universal";

const updateInfo = (data) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...data,
      },
    });
  };
};
const getInfo = () => {
  return async (dispatch) => {
    const res = await http({
      method: "GET",
      url: "/web/merchant/auth/info",
    });

    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...res.data,
      },
    });

    sessionStorage.setItem("userInfo", JSON.stringify(res.data));
  };
};

const getUserInfo = () => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });

    const res = await http({
      method: "GET",
      url: "/web/merchant/auth/info",
    });

    dispatch({
      type: actionType.UPDATE_USER_INFO,
      payload: {
        ...res.data,
      },
    });
    sessionStorage.setItem("userInfo", JSON.stringify(res.data));

    const routerRes = await http({
      method: "GET",
      url: "/web/merchant/auth/routes",
    });
    dispatch({
      type: actionType.UPDATE_MENU_LIST,
      payload: {
        menuList: routerRes.data,
      },
    });
    // dispatch({
    //   type: actionType.UPDATE_MENU_LIST,
    //   payload: {
    //     menuList: [
    //       // {
    //       //   path: "",
    //       //   component: null,
    //       //   code: "EMF001",
    //       //   children: [

    //       //   ],
    //       //   icon: null,
    //       //   name: intl.get("auth_package_menutitle"),
    //       //   id: 1,
    //       //   type: 3,
    //       //   parentId: 0,
    //       // },
    //       {
    //         path: "",
    //         component: null,
    //         code: "EMF346",
    //         children: [
    //           {
    //             path: "/find",
    //             component: "Find",
    //             code: "EMY347",
    //             children: null,
    //             iconComponent: Search,
    //             name: intl.get("auth_search_title"),
    //             id: 4,
    //             type: 1,
    //             parentId: 3,
    //           },
    //           {
    //             path: "/raidsys",
    //             component: "Raidsys",
    //             code: "EMY372",
    //             children: null,
    //             iconComponent: Send,
    //             name: intl.get("auth_connection_task"),
    //             id: 72,
    //             type: 1,
    //             parentId: 3,
    //           },
    //           {
    //             path: "/list",
    //             component: "List",
    //             code: "EMY372",
    //             children: null,
    //             iconComponent: ListChecks,
    //             name: "List",
    //             id: 73,
    //             type: 1,
    //             parentId: 3,
    //           },
    //         ],
    //         icon: null,
    //         name: intl.get("auth_connection_manage"),
    //         id: 3,
    //         type: 3,
    //         parentId: 0,
    //       },
    //       {
    //         path: "",
    //         component: null,
    //         code: "EMF346",
    //         children: [
    //           {
    //             path: "/incoming",
    //             component: "Incoming",
    //             code: "EMY348",
    //             children: null,
    //             iconComponent: SquareUserRound,
    //             name: intl.get("auth_my_talents"),
    //             id: 5,
    //             type: 1,
    //             parentId: 6,
    //           },

    //           // {
    //           //   path: "/checklist",
    //           //   component: "Checklist",
    //           //   code: "EMY377",
    //           //   children: null,
    //           //   selectedIcon: y2,
    //           //   unselectedIcon: y1,
    //           //   name: intl.get("auth_checklist_manage"),
    //           //   id: 77,
    //           //   type: 1,
    //           //   parentId: 6,
    //           // },
    //           {
    //             path: "/group",
    //             component: "userGroup",
    //             code: "EMY377",
    //             children: null,
    //             iconComponent: UsersRound,
    //             name: intl.get("auth_group_manage"),
    //             id: 78,
    //             type: 1,
    //             parentId: 6,
    //           },

    //           {
    //             path: "/creatorStatus",
    //             component: "Status",
    //             code: "EMY377",
    //             children: null,
    //             iconComponent: Activity,
    //             name: "Creator Status",
    //             id: 79,
    //             type: 1,
    //             parentId: 6,
    //           },
    //           // {
    //           //   path: "/creativeBriefs",
    //           //   component: "Briefs",
    //           //   code: "EMY377",
    //           //   children: null,
    //           //   selectedIcon: m2s,
    //           //   unselectedIcon: m2,
    //           //   name: "Creative Briefs",
    //           //   id: 80,
    //           //   type: 1,
    //           //   parentId: 6,
    //           // },
    //           {
    //             path: "/creatorMessages",
    //             component: "Messages",
    //             code: "EMY377",
    //             children: null,
    //             iconComponent: MessageSquare,
    //             name: "Creator Messages",
    //             id: 81,
    //             type: 1,
    //             parentId: 6,
    //           },
    //           {
    //             path: "/videoAnalytics",
    //             component: "Analytics",
    //             code: "EMY377",
    //             children: null,
    //             iconComponent: ChartColumn,
    //             name: "Video Analytics",
    //             id: 82,
    //             type: 1,
    //             parentId: 6,
    //           },
    //           // {
    //           //   path: "/sample",
    //           //   component: "Sample",
    //           //   code: "EMY349",
    //           //   children: null,
    //           //   selectedIcon: m5s,
    //           //   unselectedIcon: m5,
    //           //   name: intl.get("auth_sample_manage"),
    //           //   id: 7,
    //           //   type: 1,
    //           //   parentId: 6,
    //           // },
    //         ],
    //         icon: null,
    //         name: intl.get("auth_cooperation"),
    //         id: 6,
    //         type: 3,
    //         parentId: 0,
    //       },
    //       {
    //         path: "",
    //         component: null,
    //         code: "EMF346",
    //         children: [
    //           {
    //             path: "/viral",
    //             component: "Viral",
    //             code: "EMY348",
    //             children: null,
    //             iconComponent: Flame,
    //             name: intl.get("auth_viral"),
    //             id: 41,
    //             type: 1,
    //             parentId: 40,
    //           },
    //           {
    //             path: "/script",
    //             component: "Script",
    //             code: "EMY348",
    //             children: null,
    //             iconComponent: FileText,
    //             name: intl.get("auth_script"),
    //             id: 42,
    //             type: 1,
    //             parentId: 40,
    //           },
    //           {
    //             path: "/video",
    //             component: "Video",
    //             code: "EMY348",
    //             children: null,
    //             iconComponent: PlayCircle,
    //             name: intl.get("auth_video"),
    //             id: 43,
    //             type: 1,
    //             parentId: 40,
    //           },
    //           {
    //             path: "/asset",
    //             component: "Asset",
    //             code: "EMY348",
    //             children: null,
    //             iconComponent: FolderOpen,
    //             name: intl.get("auth_asset"),
    //             id: 44,
    //             type: 1,
    //             parentId: 40,
    //           },
    //           {
    //             path: "/tikTokPublish",
    //             component: "TikTokPublish",
    //             code: "EMY348",
    //             children: null,
    //             iconComponent: Upload,
    //             name: "TikTok Publish",
    //             id: 45,
    //             type: 1,
    //             parentId: 40,
    //           },
    //         ],

    //         icon: null,
    //         name: intl.get("auth_content"),
    //         id: 40,
    //         type: 3,
    //         parentId: 0,
    //       },
    //       {
    //         path: "",
    //         component: null,
    //         code: "EMF352",
    //         children: [
    //           {
    //             path: "/scriptLibrary",
    //             component: "ScriptLibrary",
    //             code: "EMY352",
    //             children: null,
    //             iconComponent: FileText,
    //             name: intl.get("auth_script_library"),
    //             id: 8,
    //             type: 1,
    //             parentId: 3,
    //           },
    //           {
    //             path: "/sendEmail",
    //             component: "SendEmail",
    //             code: "EMY356",
    //             children: null,
    //             iconComponent: Mail,
    //             name: intl.get("auth_send_email"),
    //             id: 9,
    //             type: 1,
    //             parentId: 3,
    //           },
    //           {
    //             path: "/score",
    //             component: "ScoreDeploy",
    //             // component: "ScoreConfig",
    //             // component: "Score",
    //             code: "EMY357",
    //             children: null,
    //             iconComponent: Sparkles,
    //             name: intl.get("auth_talent_score_config"),
    //             id: 11,
    //             type: 1,
    //             parentId: 3,
    //           },
    //         ],
    //         icon: null,
    //         name: intl.get("auth_ai_assistant"),
    //         id: 10,
    //         type: 3,
    //         parentId: 0,
    //       },
    //       {
    //         path: "",
    //         component: null,
    //         code: "EMF352",
    //         children: [
    //           {
    //             path: "/sub-accounts",
    //             component: "SubAccounts",
    //             code: "EMY352",
    //             children: null,
    //             iconComponent: UserCog,
    //             name: "Sub-Accounts",
    //             id: 181,
    //             type: 1,
    //             parentId: 3,
    //           },
    //           {
    //             path: "/shopList",
    //             component: "ShopList",
    //             code: "EMY354",
    //             children: null,
    //             iconComponent: Store,
    //             name: intl.get("auth_shop_list"),
    //             id: 16,
    //             type: 1,
    //             parentId: 18,
    //           },
    //         ],
    //         icon: null,
    //         name: "Work Space",
    //         id: 18,
    //         type: 3,
    //         parentId: 0,
    //       },
    //       {
    //         path: "",
    //         component: null,
    //         code: "EMF330",
    //         children: [
    //           {
    //             path: "/package",
    //             component: "Package",
    //             code: "EMY348",
    //             children: null,
    //             iconComponent: CreditCard,
    //             name: intl.get("auth_package_title"),
    //             id: 2,
    //             type: 1,
    //             parentId: 30,
    //           },
    //           {
    //             path: "/order-list",
    //             component: "OrderList",
    //             code: "EMY358",
    //             children: null,
    //             iconComponent: Receipt,
    //             name: intl.get("auth_order_title"),
    //             id: 31,
    //             type: 1,
    //             parentId: 30,
    //           },
    //         ],
    //         icon: null,
    //         name: intl.get("auth_order_menutitle"),
    //         id: 30,
    //         type: 3,
    //         parentId: 0,
    //       },
    //       // {
    //       //   path: "",
    //       //   component: null,
    //       //   code: "EMF357",
    //       //   children: [
    //       //     {
    //       //       path: "/help",
    //       //       component: "Help",
    //       //       code: "EMY358",
    //       //       children: null,
    //       //       selectedIcon: help2,
    //       //       unselectedIcon: help1,
    //       //       name: intl.get("auth_help_center"),
    //       //       id: 20,
    //       //       type: 1,
    //       //       parentId: 15,
    //       //     },
    //       //   ],
    //       //   icon: null,
    //       //   name: intl.get("auth_more"),
    //       //   id: 20,
    //       //   type: 3,
    //       //   parentId: 0,
    //       // },
    //     ],
    //   },
    // });

    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: false },
    });
  };
};

const getEnvCheck = () => {
  return async (dispatch) => {
    const res = await http({
      method: "POST",
      url: "/web/merchant/system/env/check",
    });
    if (res.code === 200) {
      dispatch({
        type: actionType.UPDATE_USER_INFO,
        payload: {
          ...res.data,
        },
      });
    }
  };
};

const changeLoading = (status) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status },
    });
  };
};

function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
}

const login = (obj, errorCallback, redirect = null) => {
  return async (dispatch) => {
    dispatch({
      type: actionType.TOGGLE_SYSTEM_LOADING,
      payload: { status: true },
    });
    try {
      const res = await http({
        method: "POST",
        url: "/web/merchant/auth/login",
        data: {
          ...obj,
        },
      });
      if (res.code === 200) {
        if (!get(res, "data.accessToken", "") || "") {
          message.error(intl.get("common_message_tokenError"));
          return;
        }
        let date = new Date();
        date.setTime(date.getTime() + (res?.data?.expiresIn || 3600) * 1000);

        document.cookie = `token=${
          get(res, "data.accessToken", "") || ""
        }; expires=${date.toUTCString()};`;

        if (isMobileDevice()) {
          window.location.href = "/mobileInvite";
        } else {
          sessionStorage.setItem("firstNewModal", "1");
          window.location.href = redirect || "/envconfig";
        }
      } else {
        errorCallback && errorCallback(res);
      }
    } catch (error) {
      console.log(error);
    }
  };
};

const register = (obj) => {
  return async () => {
    const res = await http({
      method: "POST",
      url: "/web/merchant/auth/register",
      data: {
        ...obj,
      },
    });
    if (res.code === 200) {
      message.success(intl.get("common_message_registrySuccess"));
      setTimeout(() => {
        window.location.href = `/login${window.location.search}`;
      }, 1000);
    }
  };
};

const logout = () => {
  return async () => {
    const res = await http({
      method: "POST",
      url: "/web/merchant/auth/logout",
    });

    if (res.code === 200) {
      document.cookie = "token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
      window.location.href = `/login`;
    }
  };
};

const shopInitialize = () => {
  return async (dispatch) => {
    dispatch(
      updateInfo({
        initializeLoading: true,
      }),
    );
    try {
      const res = await http({
        method: "POST",
        url: "/web/merchant/rpa-task/shop-initialize",
      });
      if (res.code === 200) {
        //
      }
    } finally {
      // dispatch(
      //   updateInfo({
      //     initializeLoading: false,
      //   })
      // );
    }
  };
};

export {
  login,
  logout,
  getInfo,
  getUserInfo,
  changeLoading,
  register,
  getEnvCheck,
  updateInfo,
  shopInitialize,
};
